//CRIANDO ACTION

import { createAction, props } from '@ngrx/store';
import { IProfessionalService } from 'src/app/shared/interfaces/profissional/iprofessionalservice';

//padrão de nomenclatura tudo maiusculo
enum ProfessionalServiceActionType {
  //textos para acomparnharmos os estados de load professional
  LOAD_PROFESSIONAL_SERVICE = '[professional] load professional service from api',
  LOAD_PROFESSIONAL_SERVICE_ID = '[professional] load professional service id from api',
  LOAD_PROFESSIONAL_SERVICE_SUCCESS = '[professional] load professional service from api return success',
  LOAD_PROFESSIONAL_SERVICE_ERROR = '[professional] load professional service from api return error',
  SAVE_PROFESSIONAL_SERVICE = '[professional] save professional service from api',
  SAVE_PROFESSIONAL_SERVICE_SUCCESS = '[professional] save professional service from api return success',
  SAVE_PROFESSIONAL_SERVICE_ERROR = '[professional] save professional service from api return error',
  EDIT_PROFESSIONAL_SERVICE = '[professional] edit professional service from api',
  EDIT_PROFESSIONAL_SERVICE_SUCCESS = '[professional] edit professional service from api return success',
  EDIT_PROFESSIONAL_SERVICE_ERROR = '[professional] edit professional service from api return error',
  DELETE_PROFESSIONAL_SERVICE = '[professional] delete professional service from api',
  DELETE_PROFESSIONAL_SERVICE_SUCCESS = '[professional] delete professional service from api return success',
  DELETE_PROFESSIONAL_SERVICE_ERROR = '[professional] delete professional service from api return error',
}
export const loadProfessionalService = createAction(
  ProfessionalServiceActionType.LOAD_PROFESSIONAL_SERVICE
);

export const loadProfessionalServiceByIdProfessional = createAction(
  ProfessionalServiceActionType.LOAD_PROFESSIONAL_SERVICE_ID,
  props<{professionalId: any}>()
);

export const loadProfessionalServiceSuccess = createAction(
  ProfessionalServiceActionType.LOAD_PROFESSIONAL_SERVICE_SUCCESS,
  props<{ lista: IProfessionalService[] }>()
);

export const loadProfessionalServiceError = createAction(
  ProfessionalServiceActionType.LOAD_PROFESSIONAL_SERVICE_ERROR
);
//vai para o effects
export const saveProfessionalService = createAction(
  ProfessionalServiceActionType.SAVE_PROFESSIONAL_SERVICE,
  props<{ professionalService: IProfessionalService }>()
);
//vai para o reducer
export const saveProfessionalServiceSuccess = createAction(
  ProfessionalServiceActionType.SAVE_PROFESSIONAL_SERVICE_SUCCESS,
  props<{ professionalService: IProfessionalService }>()
);

export const saveProfessionalServiceError = createAction(
  ProfessionalServiceActionType.SAVE_PROFESSIONAL_SERVICE_ERROR
);
//vai para o effects
export const editProfessionalService = createAction(
  ProfessionalServiceActionType.EDIT_PROFESSIONAL_SERVICE,
  props<{ professionalService: IProfessionalService; id: number }>()
);
//vai para o reducer
export const editProfessionalServiceSuccess = createAction(
  ProfessionalServiceActionType.EDIT_PROFESSIONAL_SERVICE_SUCCESS,
  props<{ professionalService: IProfessionalService }>()
);

export const editProfessionalServiceError = createAction(
  ProfessionalServiceActionType.EDIT_PROFESSIONAL_SERVICE_ERROR
);

export const deleteProfessionalService = createAction(
  ProfessionalServiceActionType.DELETE_PROFESSIONAL_SERVICE,
  props<{ id: any, professionalId: any }>()
);

export const deleteProfessionalServiceSuccess = createAction(
  ProfessionalServiceActionType.DELETE_PROFESSIONAL_SERVICE_SUCCESS,
  //props<{ id: any, professionalId: any }>()
);

export const deleteProfessionalServiceError = createAction(
  ProfessionalServiceActionType.DELETE_PROFESSIONAL_SERVICE_ERROR
);
